import React from 'react';

import Breadcrumbs from '../../components/Breadcrumb/Breadcrumbs';
import Container from './container/Container';
import Headline from '../../components/Headline/Headline';
import useCustomLocation from '../../hooks/useCustomLocation';
import { LoadingSpinner } from 'festo-react-ui-kit';
import useTranslation from '../../features/translation/hooks/useTranslation';
import { isLoginRedirect } from '../../utils';

import './MasterLayout.scss';
import useInit from '../../global/useInit';
import { useAppSelector } from '../../app/hooks';
import { useAuth } from 'react-oidc-context';
import { Outlet } from 'react-router';

const MasterLayout = () => {
  useInit();
  const { locations } = useCustomLocation();
  const translations = useAppSelector((state) => state.translations.value);

  const auth = useAuth();
  const { isLoading: userLoading, isAuthenticated } = auth;

  const t = useTranslation();

  if (isLoginRedirect() && userLoading) {
    return <LoadingSpinner text={t('spinnerLoading') + '...'} />;
  }

  return (
    <div className="container-body">
      {isAuthenticated ? (
        <Container>
          <Breadcrumbs locations={locations} />
          <Headline />
          <div className="sas-main-section">
            <Outlet />
          </div>
        </Container>
      ) : (
        <>
          {Object.keys(translations).length > 0 && (
            <Container>
              <Breadcrumbs locations={locations} />
              <Headline />
              <div className="sas-main-section">
                <Outlet />
              </div>
            </Container>
          )}
        </>
      )}
    </div>
  );
};

export default MasterLayout;
